export const CAREER_START_YEAR = 2004;

export const getCareerYears = (asOf = new Date()) => (
  Math.max(0, asOf.getFullYear() - CAREER_START_YEAR)
);

const NUMBER_WORDS = [
  'zero', 'one', 'two', 'three', 'four',
  'five', 'six', 'seven', 'eight', 'nine',
];

export const getCareerDurationLabel = (asOf = new Date()) => {
  const years = getCareerYears(asOf);

  if (years < 10) {
    return 'less than one decade';
  }

  const decades = Math.floor(years / 10);
  const count = NUMBER_WORDS[decades] ?? String(decades);
  const qualifier = years % 10 === 0 ? '' : 'more than ';

  return `${qualifier}${count} ${decades === 1 ? 'decade' : 'decades'}`;
};